import { Checkbox, Input, Textarea } from "stories";

const ImageData = ({ data, updateLabel, updateDescription, updateCover }) => {
  return (
    <>
      <Checkbox
        label={"Cover Image"}
        onChange={(e) => updateCover(e.target.checked)}
        checked={data.cover}
      />
      <Input
        label={"Label"}
        onChange={(e) => updateLabel(e.target.value)}
        value={data.label}
      />
      <Textarea
        label={"Description"}
        onChange={(e) => updateDescription(e.target.value)}
        value={data.description}
      />
    </>
  );
};

export default ImageData;
